import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import useWindowResizeEffect from 'components/hooks/useWindowResizeEffect';
import useWindowSize from 'components/hooks/useWindowSize';
import classNames from 'classnames';

import Header from './header';
import Footer from './footer';
import TopBanner from './topBanner';

const Layout = props => {
  const topBannerRef = useRef();
  const [topBannerHeight, setTopBannerHeight] = useState(0);

  const headerRef = useRef();

  const windowSize = useWindowSize();

  const updateElementsHeight = () => {
    if (topBannerRef.current && windowSize.width <= 991) {
      const { height } = topBannerRef.current.getBoundingClientRect();
      setTopBannerHeight(height);
    } else {
      setTopBannerHeight(0);
    }
  };

  useWindowResizeEffect(updateElementsHeight);

  useEffect(() => {
    updateElementsHeight();
  }, [props.showTopBanner]);

  return (
    <>
      <TopBanner
        ref={topBannerRef}
        visible={props.showTopBanner}
        onVisibleChange={updateElementsHeight}
      />
      {!props.withoutHeader && (
        <Header
          ref={headerRef}
          showNavigation={props.showNavigation}
          topPosition={topBannerHeight}
        />
      )}
      <main className={classNames('content-container', props.className)}>{props.children}</main>
      <Footer hideOnPhone={props.hideFooterOnPhone} />
    </>
  );
};

Layout.propTypes = {
  showTopBanner: PropTypes.bool,
  showNavigation: PropTypes.bool,
  withoutHeader: PropTypes.bool,
  // Editor steps end with a sticky dock on phones, no site footer there.
  hideFooterOnPhone: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

Layout.defaultProps = {
  showTopBanner: true,
  showNavigation: true,
  withoutHeader: false,
  hideFooterOnPhone: false,
};

export default Layout;
